import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_oio_modal = _resolveComponent("oio-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_oio_button, {
      class: "oio-action-item",
      size: "small",
      "data-action-name": _ctx.action.name,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validateAndClick(_ctx.action)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }, 8, ["data-action-name"]), [
      [_vShow, !_ctx.invisible]
    ]),
    _createVNode(_component_oio_modal, {
      width: "60%",
      height: "medium",
      visible: _ctx.visible,
      "onUpdate:visible": _ctx.change,
      title: "导入"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_oio_button, {
          onClick: _ctx.downloadTemplate,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("下载模板")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_oio_button, {
          onClick: _ctx.doImport,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("导入")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
          default: _withCtx(() => [
            _createVNode(_component_oio_form, null, {
              default: _withCtx(() => [
                _createVNode(_component_oio_form_item, {
                  label: "导入模板",
                  required: true,
                  validateStatus: _ctx.validation1.status,
                  help: _ctx.validation1.help
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      class: "oio-select",
                      "dropdown-class-name": "oio-select-dropdown",
                      value: _ctx.selectValue,
                      onChange: _ctx.handleSelectChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workbookList, (workbook) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            value: workbook.id,
                            key: workbook.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(workbook.displayName || workbook.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "onChange"])
                  ]),
                  _: 1
                }, 8, ["validateStatus", "help"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _: 1
    }, 8, ["visible", "onUpdate:visible"])
  ], 64))
}